// import external dependencies
import 'jquery';
import * as bootstrap from 'bootstrap';
import 'responsive-tabs';

// Import everything from autoload
import './autoload/_bootstrap.js';
import './autoload/_bootstrap-datepicker.js';

// Theme modules — each guards on its own DOM markers and bails early on pages
// where it isn't needed, so loading them all on every page stays cheap.
import * as bundles from './bundles.js';
import * as cart from './cart.js';
import * as catalogue from './catalogue.js';
import * as checkout from './checkout.js';
import * as product from './product.js';
import * as ui from './ui.js';

jQuery(function () {
    ui.init();
    catalogue.init();
    product.init();
    bundles.init();
    cart.init();
    checkout.init();
});

// clicks on .rounded-shop-button takes them to the url in data-target
jQuery(document).on('click', '.rounded-shop-button .button-content', function (e) {
    e.preventDefault();
    const targetUrl = jQuery(this).data('target');
    if (targetUrl) {
        window.location = targetUrl;
    }
});
